import { render, staticRenderFns } from "./WeixinShareShop.vue?vue&type=template&id=1ca17370&scoped=true&"
import script from "./WeixinShareShop.vue?vue&type=script&lang=js&"
export * from "./WeixinShareShop.vue?vue&type=script&lang=js&"
import style0 from "./WeixinShareShop.vue?vue&type=style&index=0&id=1ca17370&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca17370",
  null
  
)

export default component.exports